// JsFromRoutes CacheKey 80e04522a62495e3015bf0e9e84acecc
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/:org_nano_id/posts/:post_id/publish'),
}
